/* widgets module */
import Vue from 'vue';
import Nprogress from 'nprogress';
import router from '@/router';
import instance from '@/helpers/axios';
import qs from 'qs'

// load api config in your site
import {API_ENDPOINT_URL, MASTER_API_KEY, ADMIN_LOGIN_URL} from '@/config/api_config'

// get token authenticated
const siteStorage = JSON.parse(localStorage.getItem('site')) || null
const token = siteStorage != null && typeof siteStorage.token !== 'undefined' ? siteStorage.token : (localStorage.getItem('token') || null)

const state = {
    widgetName: null,
    widgetCode: null,
    widgetUrl: null,
    widgetImage: null,
    widgetStatus: false,
    widgetLoadingStatus: false,
    widgetImagePreview: null,
    widgetShowPreview: false,
    widgetCategoryInfo: {},
    WidgetCategoriesItems: [],
    widgets: [],
    allWidgets:{}
}

const getters = {
  allWidgets: state => {
      return state.allWidgets
  },
  widgetName: state => {
      return state.widgetName
  },
  widgetCode: state => {
      return state.widgetCode
  },
  widgetUrl: state => {
      return state.widgetUrl
  },
  widgetImage: state => {
      return state.widgetImage
  },
  widgetStatus: state => {
      return state.widgetStatus
  },
  widgetLoadingStatus: state => {
      return state.widgetLoadingStatus
  },
  widgetImagePreview: state => {
      return state.widgetImagePreview
  },
  widgetShowPreview: state => {
      return state.widgetShowPreview;
  },
  widgetCategoryInfo: state => {
      return state.widgetCategoryInfo
  },
  WidgetCategoriesItems: state => {
      return state.WidgetCategoriesItems
  },
  widgetsItems: state => {
    return state.widgets.map((widget) => {
      return {
        id: widget.id,
        name: widget.name,
        image: API_ENDPOINT_URL + widget.image,
        // href: `admin/widget/${state.widgetCategoryInfo.name}/${widget.code}`
        href: widget.url,
        actions: {
          view: false
        }
      }
    })
  },
  widgetsCategoryFromSlug: state => {
    return {
      id: state.widgetCategoryInfo.id,
      name: state.widgetCategoryInfo.name,
      slug: state.widgetCategoryInfo.slug
    }
  }
}

const actions = {
    async createWidgetCategory(context, payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
        
            await instance.post(API_ENDPOINT_URL+'widgettypes',{
                access_token : token,
                name: input_form.name,
                code: input_form.code,
                status: input_form.status ? 1 : 0
            })
            .then(response => {
                Nprogress.start();

                setTimeout(() => {
                    context.commit('WidgetCategorySuccess');
                },1000);
            })
            .catch(error => {
                context.commit('addWidgetCategoryFailure', error);
            });
        }
    },
    async updateWidgetCategory(context,payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
            await instance.put(API_ENDPOINT_URL+'widgettypes/'+input_form.id,{
                access_token : token,
                name: input_form.name,
                code: input_form.code,
                status: input_form.status ? 1 : 0
            })
            .then(response => {
                Nprogress.start();
                setTimeout(() => {
                    context.commit('WidgetCategorySuccess');
                },1000);
            })
            .catch(error => {
               console.log(error.response.data);
            });
        }
    },
    async getListCategory(context,payload) {
        const filter_search = payload !="" ? payload : null;

        await instance.get(API_ENDPOINT_URL+'widgettypes')
            .then(response => {
                context.commit('getCategories',response);
            })
            .catch(error => {
                console.log(error.response.data);
            });
    },
    async getCategoryName(context,item_id) {
        if (item_id != '') {
            let cate_name = await instance.get(API_ENDPOINT_URL+'widgettypes/'+item_id);
            return cate_name;
        }
    },
    async getDataCategory(context,item_id) {

        if (item_id != '') {
            await instance.get(API_ENDPOINT_URL+'widgettypes/'+item_id)
                .then(response => {
                    context.commit("loadFormDataCategory",response);
                })
                .catch(error => {
                    console.log(error.response.data);
                });
        }
    },
    async removeWidgetCategory(context,payload) {
        const item = payload;
        const item_id = item.id;

        if (item_id) {
            await instance.delete(API_ENDPOINT_URL+'widgettypes/'+item_id)
                .then(response => {
                    Nprogress.start();
                    if (response.status == 204) {
                        Nprogress.done();
                    }
                })
                .catch(error => {
                    console.log(error.response.data);
                });
        }
    },
    async loadFormWidgetData (context, payload) {
        const widget_id = payload;

        await instance.get(`${API_ENDPOINT_URL}widgets/${widget_id}`)
            .then(response => {
                if (response.status == 200) {
                    const result = response.data;
                    context.commit("stateFormWidgetData",result);
                }
            }).catch(error => {
                console.log(error.response.data);
            });
    },
    async createWidget (context, payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
        
            await instance.post(`${API_ENDPOINT_URL}widgets`,input_form,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {

                Nprogress.start();

                setTimeout(() => {
                    context.commit("WidgetNotify",'Widget Created!');
                },1000);
            })
            .catch(error => {
                context.commit('addWidgetFailure', error);
            });
        }
    },
    async updateWidget(context,payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
            await instance.put(`${API_ENDPOINT_URL}widgets/${input_form.id}`,input_form,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {

                Nprogress.start();
                setTimeout(() => {
                    context.commit("WidgetNotify",'Widget Updated!');
                },1000);
            })
            .catch(error => {
                context.commit("addWidgetFailure",error);
            });
        }
    },
    async removeWidget(context,payload) {
        const item = payload;
        const item_id = item.id;
        if (item_id) {
            await instance.delete(`${API_ENDPOINT_URL}widgets/${item_id}`)
            .then(response => {
                Nprogress.start();
                if (response.status == 204) {
                    context.commit("WidgetNotify",'Widget Deleted!');
                }
            })
            .catch(function (error) {
                context.commit("addWidgetFailure",error);
            });
        }
    },
    async getWidgets(context, payload) {
      const filters = {
        params: qs.parse(payload)
      };

      await instance.get('widgettypes/widgets', filters)
        .then(response => {
          const rows = response.data;
          context.commit('getWidgets',rows.widgets);
          context.commit('getCategoryFromSlug',rows);
        })
        .catch(error => {
          console.log(error);
        });
    },

    async getAllWidgets(context, payload) {
      var _params = {fields:"name,url,label",limit:100};
      const request = {
            params: qs.parse(_params)
        };
      await instance.get('widgets', request)
        .then(response => {
          const {rows} = response.data;
          let allWidgets = {};
          rows.forEach(function(item,index){
            var urls = item.url.split('/');
            var id = parseInt(urls[urls.length-1]);
            allWidgets['widget-id-'+id] = item;            
          });
          context.commit('setAllWidgets',allWidgets);

        });  
    },

    async getAllWidgetsPub(context, payload) {
      var _params = {fields:"name,url,label",limit:100};
      const request = {
            params: qs.parse(_params)
        };
      await instance.get('widgets/public', request)
        .then(response => {
          const {rows} = response.data;
          state.allWigets = {};
          rows.forEach(function(item,index){
            var urls = item.url.split('/');
            var id = parseInt(urls[urls.length-1]);
            state.allWidgets['widget-id-'+id] = item;            
          });
        });  
    },


    async getWidgetsAll(context, payload) {
      const filters = {
        params: qs.parse(payload)
      };

      await instance.get('widgets', filters)
        .then(response => {
          const { rows } = response.data;
          context.commit('getWidgets',rows);
        })
        .catch(error => {
          console.log(error);
        });
    }
}

const mutations = {
  WidgetCategorySuccess(state, response) {
      
      Nprogress.done();
      router.push("/admin/setting/category");

      Vue.notify({
          group: 'loggedIn',
          type: 'success',
          text: 'Widget Category Created!'
      });

  },
  addWidgetCategoryFailure(state, error) {
      Nprogress.done();
      Vue.notify({
          group: 'loggedIn',
          type: 'error',
          text: error.message
      });
  },
  WidgetNotify(state, message) {
      Nprogress.done();
      router.push("/admin/setting/widgets");

      Vue.notify({
          group: 'loggedIn',
          type: 'success',
          text: message
      });
  },
  addWidgetFailure(state, error) {
      Nprogress.done();

      let error_info = '';
      if (error.response) {
          error_info = error.response.data;
      }

      Vue.notify({
          group: 'loggedIn',
          type: 'error',
          text: error_info.message
      });
  },
  getCategories(state,response) {
      state.form_data_status = false;
      state.WidgetCategoriesItems = response.data.rows;
  },
  loadFormDataCategory(state,response) {
      state.form_data_status = true;
      state.category_info = response.data;
  },
  clearFromDataCategory(state) {
      state.name = null;
      state.code = null;
      state.category_info = {};
  },
  stateFormWidgetData (state, response) {
      state.widgetName = response.name;
      state.widgetCode = response.type;
      state.widgetImage = response.image;
      state.widgetStatus = response.status;
      state.widgetUrl = response.url;
      state.widgetImagePreview = `${API_ENDPOINT_URL}${response.image}`;
      state.widgetShowPreview = true;
  },
  getWidgets(state,widgets) {
    state.widgets = widgets;
  },
  setAllWidgets(state,widgets) {
    state.allWidgets = widgets;
  },
  getCategoryFromSlug(state,category) {
    state.widgetCategoryInfo = category;
  },
}

export default {
    state,
    getters,
    actions,
    mutations
}